export default {
  GET_LIST: '/manage/claim/findList',
  SAVE_CLAIM: '/manage/claim/updateRelation',
  GET_CLAIM_DETAIL: '/manage/claim/getClaimById',
  GET_TITLE: '/manage/claim/findBasfClaimsByEnTitle',
  EXPORT: '/manage/claim/export',
  GET_MATCHING_LIST: '/manage/claim-relation/findList',
  CHANGE_MATCHING_STATUS: '/manage/claim-relation/enableOperate',
  GET_MATCHING_DETAIL: '/manage/claim-relation/detail',
  SAVE_MATCHING: '/manage/claim-relation/updateRelation',
  DEL_TRANSLATION: '/manage/claim/delete',
  ADD_TRANSLATION: '/manage/claim/save',
  EDIT_TRANSLATION: '/manage/claim/update'
}



// WEBPACK FOOTER //
// ./src/axios/api_urls/claim.js